<template>
    <header>
        <div class="header">
            <button id="menu-toggle" @click="toggleMenu" :class="{'open': open}">
                <span class="sr-only">
                    {{ $t(`labels.toggle_menu`) }}
                </span>
                <span v-if="open" class="close-icon" aria-hidden="true"></span>
                <span v-else class="icon-toggle" aria-hidden="true"></span>

            </button>
            <a :href="$t(`main.${site}.site_root`)" class="home-logo" :title="$t(`main.${site}.logo_link_title`)">
                <img :alt="$t(`main.${site}.logo_alt`)" :src="siteLogo"/>
            </a>
        </div>
        <nav :class="{'show': open}">
            <ul>
                <li>
                    <router-link :to="{name: 'basic-search'}" class="nav-link" exact>{{ $t('menu.search') }}</router-link>
                </li>
                <li v-if="hasCollections">
                    <router-link :to="{name: 'collections'}" class="nav-link">{{ $t('menu.collections') }}</router-link>
                </li>
                <!-- <li>
                    <router-link :to="{name: 'resources'}" class="nav-link">{{ $t('menu.resources') }}</router-link> 
                </li> -->
                <li>
                    <router-link :to="{name: 'saved-list'}" class="nav-link">
                        {{ $t('menu.saved') }}
                    </router-link>
                </li>
                <li><a :href="$t(`menu.${site}.visit`)">{{ $t('menu.visit') }}</a></li>
                <li><a :href="$t(`menu.${site}.exhibitions`)">{{ $t('menu.exhibitions') }}</a></li>
                <li><a :href="$t(`menu.${site}.learn`)">{{ $t('menu.learn') }}</a></li>
                <li><a :href="$t(`menu.${site}.shop`)">{{ $t('menu.shop') }}</a></li>
                <li><a :href="$t(`menu.${site}.support`)">{{ $t('menu.support') }}</a></li>
                <li><a :href="$t(`menu.${site}.about`)">{{ $t('menu.about') }}</a></li>
                <li v-if="isEn" ><a :href="$t(`menu.${site}.french`) + route">{{ $t('menu.french') }}</a></li>
                <li v-else><a :href="$t(`menu.${site}.english`) + route">{{ $t('menu.english') }}</a></li>
            </ul>
        </nav>
    </header>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'Header',
    data () {
        return {
            open: false
        }
    },
    computed: {
        ...mapGetters({
            'site': 'search/site'
        }),
        isEn: function () {
            return this.$i18n.locale == 'en';
        },
        route: function () {
            return this.$route.fullPath.substring(1);
        },
        siteLogo: function () {
            let imgName = this.$i18n.messages[this.$i18n.locale].main[this.site].museum_name_img;
            return require('../assets/'+imgName)
        },
        hasCollections () {
            if (!this.site) return false;

            let content = this.$i18n.messages[this.$i18n.locale].collections_page[this.site];
            return content.collections.length;
        },
    },
    methods: {
        toggleMenu () {
            this.open = !this.open;
        }
    },
    watch: {
        '$route' () {
            this.open = false;
        }
    }
}
</script>

<style scoped lang="scss">
    $tablet-height: 60px;

    header {
        background: $white;
        position: relative;

        .header {
            display: flex;
            justify-content: flex-start;
            height: $tablet-height;
            border-bottom: solid 1px $light-gray1;
        }

        .home-logo {
            padding-left: $side-padding-mobile;
            display: flex;
            img {
                width: 60%;
            }
        }

        #menu-toggle {
            border: none;
            width: $tablet-height;
            cursor: pointer;
            padding: 0;

            &.open, &:hover {
                background: $menu-gray;
            }

            .icon-toggle {
                &:after {
                    height: 18px;
                    content: url('../assets/images/icon-menu-toggle.svg');
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    transform: scale(.8);
                }
            }

            .close-icon {
                &:after {
                    content: '';
                    background-image: url('../assets/images/icon-close-x.svg');
                    background-size: 30px 30px;
                    background-position: center center;
                    background-repeat: no-repeat;
                    display: block;
                    height: $tablet-height;
                    width: $tablet-height;
                    position: relative;
                    filter: brightness(2);
                }
            }

            &.open:hover {
                background: $med-gray1;
            }
        }

        nav {
            display: none;

            &.show {
                display: block;
            }
            
            ul {
                background: $dark-gray1;
                display: flex;
                flex-direction: column;
                align-items: center;
                position: relative;
                width: 100%;

                li {
                    z-index: 2;
                    margin: 0 $s2;
                    box-sizing: border-box;
                    width: 100%;
                    border-top: solid 1px rgba($menu-gray, .5);
                    
                    &:hover {
                        background: #3d3d3d;
                    }

                    a {
                        display: block;
                        padding: 1.2rem;
                        padding-left: $side-padding-mobile;
                        width: 100%;
                        color: $white;
                        text-decoration: none;
                        font-weight: bold;
                        text-transform: uppercase;
                    }
                }
            }
        }
    }

    .cmh #menu-toggle {
        background: $cmh-red;
    }

    .cwm #menu-toggle {
        background: $cwm-green-menu;
    }


    
    @media print {
        header ul,
        #menu-toggle {
            display: none;
        }
    }

    @media (min-width: $mq-max-width-tablet) {
        header {
            display: none;
        }   
    }
</style>